import { render, staticRenderFns } from "./LandingScreen.vue?vue&type=template&id=66cf4522&"
import script from "./LandingScreen.vue?vue&type=script&lang=js&"
export * from "./LandingScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports